import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { DEVICE } from '@/constant/unit/device';
export const S = {
    PopupBody: styled.div `
    width: calc(100% - 30px);
    height: calc(100% - 83px - 103px);

    overflow: auto;
    border-bottom: 1px solid rgb(93 134 90 / 50%);
  `,
    PopupBodyComment: styled.div `
    min-height: 80px;
    padding: 0 10px;
    margin-bottom: 5px;

    font-size: 16px;
    line-height: 26px;
    color: ${SEMANTIC_COLORS.COMMENT_TEXT};
  `,
    // Date
    LayoutDatesGrid: styled.div `
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 20px;
    column-gap: 22px;
    width: 100%;
    padding: 0 15px;
    margin: 16px 0 35px;
  `,
    // Time
    LayoutAlignCenter: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100%;
  `,
    LayoutTimeSelector: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% - 60px);
    height: 180px;
    margin: 0 auto;
    font-size: 48px;

    font-weight: 500;
    line-height: 70px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};

    @media ${DEVICE.mobileM} {
      height: 200px;
    }
  `,
    TimeSelector: styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 70px;
    height: 100%;
  `,
    TimeSelectorDivider: styled.div `
    margin: 0 20px 10px;

    @media ${DEVICE.mobileM} {
      margin: 0 30px 10px;
    }
  `,
    PopupFooter: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 103px;

    & > button {
      margin: 0 19px;
    }
  `,
};
